/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetAutoMediaListMediaOutletsResponseAllOf,
    GetAutoMediaListMediaOutletsResponseAllOfFromJSON,
    GetAutoMediaListMediaOutletsResponseAllOfFromJSONTyped,
    GetAutoMediaListMediaOutletsResponseAllOfToJSON,
} from './GetAutoMediaListMediaOutletsResponseAllOf';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    PrtimesMediaOutlet,
    PrtimesMediaOutletFromJSON,
    PrtimesMediaOutletFromJSONTyped,
    PrtimesMediaOutletToJSON,
} from './PrtimesMediaOutlet';

/**
 * 
 * @export
 * @interface GetAutoMediaListMediaOutletsResponse
 */
export interface GetAutoMediaListMediaOutletsResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetAutoMediaListMediaOutletsResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetAutoMediaListMediaOutletsResponse
     */
    message: string;
    /**
     * 
     * @type {Array<PrtimesMediaOutlet>}
     * @memberof GetAutoMediaListMediaOutletsResponse
     */
    mediaOutlets: Array<PrtimesMediaOutlet>;
    /**
     * メディアの総数
     * @type {number}
     * @memberof GetAutoMediaListMediaOutletsResponse
     */
    totalCount: number;
}

export function GetAutoMediaListMediaOutletsResponseFromJSON(json: any): GetAutoMediaListMediaOutletsResponse {
    return GetAutoMediaListMediaOutletsResponseFromJSONTyped(json, false);
}

export function GetAutoMediaListMediaOutletsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutoMediaListMediaOutletsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'mediaOutlets': ((json['media_outlets'] as Array<any>).map(PrtimesMediaOutletFromJSON)),
        'totalCount': json['total_count'],
    };
}

export function GetAutoMediaListMediaOutletsResponseToJSON(value?: GetAutoMediaListMediaOutletsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'media_outlets': ((value.mediaOutlets as Array<any>).map(PrtimesMediaOutletToJSON)),
        'total_count': value.totalCount,
    };
}

